/**
 * Zero-data, no-results, and error placeholders. Always names the reason and
 * offers the next action.
 * Spec: assets/handoffs/design_system_export/specs/EmptyState.json
 *
 * The spec's `variants` (noData/noResults/error/limitReached) are copy
 * presets, not component modes — pass title/body/actions directly; `variant`
 * here only controls the featured-icon color treatment (error vs. neutral).
 *
 * @param {ReactNode=} icon
 * @param {'neutral'|'error'=neutral} variant
 * @param {string} title
 * @param {string=} body
 * @param {Array<{label:string,hierarchy?:string,onClick?:function}>=[]} actions
 */
import React from "react";
import classNames from "classnames";
import Button from "../Button/Button";
import styles from "./EmptyState.module.scss";

const EmptyState = ({ icon, variant = "neutral", title, body, actions = [], className, ...rest }) => {
  return (
    <div className={classNames(styles.root, className)} {...rest}>
      {icon && (
        <span
          className={classNames(styles.featuredIcon, styles[`featuredIcon--${variant}`])}
          aria-hidden="true"
        >
          {icon}
        </span>
      )}
      {title && <h3 className={styles.title}>{title}</h3>}
      {body && <p className={styles.body}>{body}</p>}
      {actions.length > 0 && (
        <div className={styles.actions}>
          {actions.map((action, i) => (
            <Button
              key={action.label || i}
              hierarchy={action.hierarchy || "secondaryGray"}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
